var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload"},[_c('input',{attrs:{"type":"file","accept":_vm.accept,"multiple":_vm.multiple},on:{"change":_vm.uploadFile}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }